var path = '/templates/projects.dashboard/delivery_chart.html';
var html = "<div class=widget-header><h5>{{ 'projectsDashboard.deliveryChart.haishin_kazu_nakaguro' | translate }}</h5></div><div class=widget-content><div ng-if=$ctrl.project.dailyReportStats class=chart-component><highchart config=$ctrl.chartConfig></highchart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.dashboard/delivery_chart.html
// module id = 1452
// module chunks = 0